export default "__VITE_ASSET__BJeV3ZHA__"